import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import commonData from './modules/common'
import permission from './modules/permission'
import getters from './getters'
import enhance from './modules/enhance'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    commonData,
    enhance
  },
  state: {},
  mutations: {},
  actions: {},
  getters
})
